import { ACCOUNT_ID_NAME, BI_TOKEN_NAME, MFA_COMPLIANCE_SETUP_PENDING } from './constants'
import { removeGhostTokenCookies, removeToken } from './token'

export const clearSession = () => {
  removeToken()
  removeGhostTokenCookies()
  window.localStorage.removeItem(BI_TOKEN_NAME)
  window.localStorage.removeItem(ACCOUNT_ID_NAME)
  window.localStorage.removeItem(MFA_COMPLIANCE_SETUP_PENDING)
}
